module.exports = __webpack_public_path__ + "static/img/industry02.a77754f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/industry02.png
// module id = AgFN
// module chunks = 0